export default [
  [['name', 'ASC']],
  [['name', 'DESC']],
]
